export default "__VITE_ASSET__CUV3kufD__"